import * as yup from "yup";

import { elementValidations } from "@/utils/validations/element";

export const linkFormSchema = yup
  .object({
    url: yup.string().required("Required").url(`You must enter a valid URL including protocol, e.g., “https://”`),
    title: elementValidations.title,
    experienceId: elementValidations.experienceId,
    mediaItemId: elementValidations.mediaItemId,
    type: elementValidations.type,
    status: elementValidations.status,
    scope: elementValidations.scope,
    shape: elementValidations.shape,
    showText: elementValidations.showText,
    size: elementValidations.size,
    color: elementValidations.color,
    textColor: elementValidations.textColor,
    linkDestination: elementValidations.linkDestination,
    positioning: elementValidations.positioning,
    xFrameOptions: elementValidations.xFrameOptions,
    helperText: elementValidations.helperText,
    fileName: elementValidations.fileName,
    fileSize: elementValidations.fileSize,
    iconLink: elementValidations.iconLink,
    iconName: elementValidations.iconName,
    linkedId: elementValidations.linkedId,
    isEmbeddable: elementValidations.isEmbeddable,
  })
  .required();

export type LinkFormData = yup.InferType<typeof linkFormSchema>;
